module.exports = __webpack_public_path__ + "static/img/mark6.32ac912.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/markdown/mark6.png
// module id = xtIB
// module chunks = 0